import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import UploadItem from './upLoadItem';
import RelationTaskDetail from '../../../../view/components/manuscriptPool/RelationTaskDetail';
import UploadPic from '../uploadPic';
import upload from '../images/upload.png';
import manuscriptPic from '../images/manuscriptPic.png';
import timePic from '../images/timePic.png';
import taskPic from '../images/taskPic.png';
import './index.scss';

const PictureItem = (props) => {

    const relationTaskDetail = useRef();
    const uploadPic = useRef();

    const seeTaskInfo = () => {
        relationTaskDetail.current.taskDetailShow(props.itemData.id);
    }

    const uploadInfo = () => {
        uploadPic.current.showUploadPic(props.itemData);
    }

    const getIcons = () => {
        const { showType, title } = props;
        let Icons = [];
        if (title === '附件池') {
            if ((showType === 'manuscript') || (showType === 'manuscript-time') || (showType === 'task-time')) {
                //稿件附件池 不要预览和删除
                Icons = ['download'];
            } else {
                //任务附件
                Icons = ['download', 'delete'];
            }
        }
        if (title === '图片池' || title === '视频池') {
            if ((showType === 'manuscript') || (showType === 'manuscript-time') || (showType === 'task-time')) {
                //与稿件相关
                Icons = ['eye','play', 'download'];
            } else {
                //与任务相关
                Icons = ["eye", 'play',"download", "delete"];
            }
        }
        return Icons
    }

    const { itemData, showType, title } = props


    return (
        <>
            <div className="picture-pool-box">
                <div className="part_1">
                    <div className="left">
                        <div className="pic">
                            <img src={showType === 'manuscript' ? manuscriptPic : (showType === 'task' ? taskPic : timePic)} alt="" />
                        </div>
                        <span style={{ cursor: showType === 'task' ? 'pointer' : 'unset' }} onClick={showType === 'task' ? seeTaskInfo : () => { }}>{itemData.title}</span>
                    </div>
                    <div className="right">
                       {/* //4是已完成 除了已完成其余的都显示按钮*/}
                        <div className="pic" style={{ display: (showType === 'task' && itemData.status < 4) ? 'flex' : 'none' }} onClick={((showType === 'task') || (showType === 'task-time')) ? uploadInfo : () => { }}>
                            <img src={upload} alt=" " />
                            <span style={{color:props.newSecondSelectColor}}>上传</span>
                        </div>
                    </div>
                </div>
                <div className="part_2">
                    {
                        title === '图片池' ? <UploadItem taskId={itemData.id} item={itemData} fileList={props.itemData.fileList} showIcon={getIcons()} fileType="图片" key={itemData.title} /> : (
                            title === '视频池' ? <UploadItem taskId={itemData.id} item={itemData} fileList={props.itemData.fileList} showIcon={getIcons()} fileType="视频" key={itemData.title} /> : (
                                title === '附件池' ? <UploadItem taskId={itemData.id} item={itemData} fileList={props.itemData.fileList} showIcon={getIcons()} fileType="附件" key={itemData.title} /> : ''
                            )
                        )
                    }
                </div>
            </div>
            <RelationTaskDetail ref={relationTaskDetail} />
            <UploadPic refs={uploadPic} title={title} taskName={itemData.title} search={props.search} />
        </>
    )
}

PictureItem.defaultProps = {
    itemData: {
    }
}

PictureItem.propTypes = {
    itemData: PropTypes.object.isRequired, //每一项item的数据  //稿件（稿件名称、稿件包含图片list）  任务（任务名称、任务id、任务包含图片list）
    showType: PropTypes.string, //按任务（task） 、任务时间 (task-time)、 稿件(manuscript)、稿件时间(manuscript-time)

}

export default PictureItem